import SendWebEvent from "../../../../contents/docs/integrate/send-events/_snippets/send-events-web.mdx";
import * as React from 'react';
export default {
  SendWebEvent,
  React
};